import { styled } from "@mui/material";

export const Image = styled("img")(({ theme }) => ({
  maxHeight: theme.spacing(8),
  maxWidth: theme.spacing(16),
  margin: `${theme.spacing(2)} 0`,
}));
